import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import ThumbUp from '@mui/icons-material/ThumbUp';

import { Typo } from 'uikit/content';

import { getLearnerViewDurationStringFromSeconds } from '@/exceed';

import getUTCDateString from '../helpers/getUTCDateString';

import styles from '../styles/videoContentInformationMeta.module.scss';

const DIFFICULTY_MAPPING = { 1: 'Beginner', 2: 'Intermediate', 3: 'Advanced' };

/* eslint-disable camelcase */
const VideoContentInformationMeta = ({
  author = null,
  published_at = '',
  duration = 0,
  difficulty = 0,
  vote_total = 0,
  type = 'on-demand',
}) => (
  <div className={styles.meta}>
    <div className={styles.meta_data}>
      {author && (
        <Typo className={styles.meta_data_item} variant="label2">
          {i18n.t('author-label', { author })}
        </Typo>
      )}
      {published_at && (
        <Typo className={styles.meta_data_item} variant="label2">
          {i18n.t('published-date', { date: getUTCDateString(published_at) })}
        </Typo>
      )}
      {Boolean(duration) && (
        <Typo className={styles.meta_data_item} variant="label2">
          {getLearnerViewDurationStringFromSeconds(duration)}
        </Typo>
      )}
      {Boolean(difficulty)
        && <Typo className={styles.meta_data_item} variant="label2">{DIFFICULTY_MAPPING[difficulty]}</Typo>}
      {type !== 'live' && (
        <Typo className={styles.meta_data_item} variant="label2">
          <ThumbUp sx={{ height: 18, width: 18 }} />
          +
          {vote_total}
        </Typo>
      )}
    </div>
  </div>
);

VideoContentInformationMeta.propTypes = {
  author: PropTypes.string,
  published_at: PropTypes.string,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  difficulty: PropTypes.number,
  vote_total: PropTypes.number,
  type: PropTypes.string,
};

export default React.memo(VideoContentInformationMeta);
